import React, { useEffect } from 'react';
import MobileHeader from './MobileHeader';
import SlideInLeftPanel from './SlideInLeftPanel';
import Backdrop from './Backdrop';
import GestureHandler from './GestureHandler';
import './MobileView.css';

const MobileView = ({
  isDarkMode,
  title,
  isPanelOpen,
  onPanelOpen,
  onPanelClose,
  onTitleClick,
  activeView,
  onViewChange,
  onPrimaryAction,
  onSecondaryAction,
  panelContent,
  children,
  userInfo,
  onUserClick,
}) => {
  useEffect(() => {
    if (!isPanelOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onPanelClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPanelOpen, onPanelClose]);

  return (
    <div className={`mobile-view ${isDarkMode ? 'dark-mode' : ''}`}>
      <GestureHandler
        isPanelOpen={isPanelOpen}
        onOpen={onPanelOpen}
        onClose={onPanelClose}
      >
        <MobileHeader
          title={title}
          onMenuClick={onPanelOpen}
          onTitleClick={onTitleClick}
          activeView={activeView}
          onViewChange={onViewChange}
          onPrimaryAction={onPrimaryAction}
          onSecondaryAction={onSecondaryAction}
          userInfo={userInfo}
          onUserClick={onUserClick}
        />
        <div className="mobile-view-content">
          {children}
        </div>
        <Backdrop isVisible={isPanelOpen} onClick={onPanelClose} />
        <SlideInLeftPanel isOpen={isPanelOpen}>
          {panelContent}
        </SlideInLeftPanel>
      </GestureHandler>
    </div>
  );
};

export default MobileView;
